import React from "react";
import styled, { keyframes } from "styled-components";

const fill = keyframes`
  from {
    height: 0px;
  }
  to {
    height: ${({ height, value }) => (value / height) * 100}%
  }
`;

const StyledBar = styled.div`
  width: 100%;
  height: calc(${({ height, value }) => (Math.abs(value) / height) * 150}px);
  background-color: ${({ value, current, selected, theme }) => value < 0 ? '#ff0000' : (current ? theme.main : (selected ? '#414141' : theme.lightGrey))};
  opacity: ${({ value, current, selected }) => (value < 0 || current) && !selected ? 0.5 : 1};
  border-radius: 18px;
  animation: ${fill} 1s ease 0.5s;
`;

const Bar = ({ ...props }) => (
  <StyledBar {...props}/>
);

export default Bar;


// WEBPACK FOOTER //
// ./src/artzu-ui/src/BarGraph/Bar.js